import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerModalBaseComponent } from '../shared/customer-modal-base.component';
import { UspvsService } from './uspvs.service';

export class UspvsModalContext {
    public passportId: string;
    public dateOfBirth: string;
    public validationCode: string;

    constructor(
        public legacySequenceNumber: string,
        public customerNumberId: number = null
    ) { }
}

@Component({
    selector: 'uspvs-modal',
    templateUrl: './uspvs-modal.html'
})
export class UspvsModalComponent extends CustomerModalBaseComponent {
    public uspvsVerificationForm: UntypedFormGroup;
    public showValidationCode = false;
    public loadingUspvsMessage = false;
    public showButtonLoading = false;

    constructor(
        private upsvsService: UspvsService,
        private dialogRef: MatDialogRef<UspvsModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: UspvsModalContext,
        public modalService: MvdModalService,
        private fb: UntypedFormBuilder
    ) {
        super(modalService);

        this.displayResults = false;
    }

    public ngOnInit(): void {
        this.buildForm();
    }

    public buildForm(): void {
        this.uspvsVerificationForm = this.fb.group({
            'legacySequenceNumber': [this.data.legacySequenceNumber],
            'passportNumber': [this.data.passportId || '', Validators.required],
            'dateOfBirth': [this.data.dateOfBirth || '', Validators.required]
        });

        this.displayResults = true;
    }

    public cancel(): void {
        this.dialogRef.close();
    }

    public search(): void {
        this.showValidationComponent = false;
        if (this.uspvsVerificationForm.valid) {
            this.loadingUspvsMessage = true;
            this.showButtonLoading = true;
            this.upsvsService.UspvsCheck(this.uspvsVerificationForm.get('passportNumber').value, this.uspvsVerificationForm.get('dateOfBirth').value)
                .subscribe(result => {
                    this.data.validationCode = result.result ? 'Y' : 'N';
                    this.showValidationCode = true;
                    this.showButtonLoading = false;
                }, e => {
                    this.showButtonLoading = false;
                    if (e.status == 400) {
                        this.handleValidationResult(e);
                    } else {
                        this.showValidationComponent = false;
                        this.data.validationCode = 'S';
                        this.showValidationCode = true;
                    }

                    this.loadingUspvsMessage = false;
                }, () => {
                    this.loadingUspvsMessage = false;
                    this.showButtonLoading = false;
                });
        } else {
            this.uspvsVerificationForm.get('passportNumber').markAsTouched();
            this.uspvsVerificationForm.get('dateOfBirth').markAsTouched();
        }
    }
}
